export const dark = {
  name: "dark-theme",
  colors: {
      bg: "#ffffff",
      headline: "#301e4e",
      paragraph: "grey",
      cardBG: "#ffffff",
      cardText: "#000000",
      ff: "Open Sans",
      activeColor: "#7e46bc",
      activeColorDarkened: "#6b3aa0",
      contrastText: "#000000",
      borderColor: "#DDDDDD",
      opacityColor: "#f7f7f7",
      subTextColor: "#717171",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
      themeToggleTranslate: 'translateX(0px)',
      themeToggleContrast: 'grey',
      themeActiveDisabled: '#e0e0e0'

  },
};

export const light = {
  name: "light-theme",
  colors: {
    bg: "#301e4e",
    headline: "#ffffff",
    paragraph: "#c9bae2",
    cardBG: "#463366",
    cardText: "#cabae2",
    ff: "Open Sans",
    activeColor: "#ff6e6c",
    activeColorDarkened: "#ff6e6c",
    contrastText: "#ffffff",
    borderColor: "#DDDDDD",
    opacityColor: "#cabae2",
    subTextColor: "",
    boxShadow: "",
    themeToggleTranslate: 'translateX(34px)',
    themeToggleContrast: 'white',
    themeActiveDisabled: '#7CB777'
  },
};
